import { VStack, HStack } from '@chakra-ui/react';
import { IconButton, Button } from 'Atoms';
import { Dispatch, SetStateAction } from 'react';
import { Typography } from 'Tokens';
import { ArrowNarrowLeftIcon } from 'Tokens/Icons/Direction';
import { MfDisclosureRequirementTableMetric } from './DrMateriality.hooks';

export const MFDatapointsDRBrowserViewHistory = ({
  viewHistory,
  setViewHistory,
  subCategoryMap,
}: {
  viewHistory: string[];
  setViewHistory: Dispatch<SetStateAction<string[]>>;
  subCategoryMap: {
    [key: string]: { name: string; metrics: MfDisclosureRequirementTableMetric[] };
  };
}) => {
  return (
    <VStack justifyItems={'flex-start'} paddingBottom={'4px'}>
      <HStack gap={'4px'} alignSelf={'start'}>
        <IconButton
          icon={<ArrowNarrowLeftIcon />}
          size="xs"
          variant="ghost"
          aria-label={'Back'}
          onClick={() => {
            setViewHistory((prevHistory) => {
              return prevHistory.slice(0, prevHistory.length - 1);
            });
          }}
        />
        <HStack gap={'2px'}>
          {viewHistory.map((view, idx) => {
            return (
              <HStack gap={'2px'}>
                <Button
                  size="xs"
                  variant="ghost"
                  p="1px 2px"
                  justifyContent="flex-start"
                  _hover={{ bg: !(idx === viewHistory.length - 1) ? 'bg.hover' : 'unset' }}
                  cursor={idx === viewHistory.length - 1 ? 'auto' : 'pointer'}
                  maxW="500px"
                  onClick={() => {
                    if (idx !== viewHistory.length - 1) {
                      if (idx === 0) {
                        setViewHistory([viewHistory[0]]);
                      }
                    }
                  }}
                >
                  <Typography
                    fontSize={'14px'}
                    color={idx === viewHistory.length - 1 ? 'text.hint' : 'text.default'}
                    textOverflow="ellipsis"
                    overflow={'hidden'}
                  >
                    {idx === 0 ? view : subCategoryMap[view].name}
                  </Typography>
                </Button>
                {idx !== viewHistory.length - 1 && (
                  <Typography marginRight={'2px'} color={'text.hint'}>
                    /
                  </Typography>
                )}
              </HStack>
            );
          })}
        </HStack>
      </HStack>
      <Typography alignSelf={'flex-start'}>{subCategoryMap[viewHistory[1]].name}</Typography>
    </VStack>
  );
};
